import { useContext, useEffect, useMemo, useState } from 'react';
import { ConfigContext } from '@/contextAPI/configContext';
import { useAppSelector } from '@/redux/hooks';
import { selectCurrentTableBulkActions, selectCurrentTableKey, selectUserColumns } from '@/redux/selectors/dataTableSelectors';
import { TableHeaderCheckbox, TableRowCheckbox } from '@/exports/columnCommonComponents';
import { OrderJob } from '@/redux/slices/slice_types';

const useColumns = () => {
  const bulkSelectColumnsConfig = useContext(ConfigContext)?.bulkSelectColumns || ['hid', 'job_type', 'description', 'status'];
  const tableKey = useAppSelector(selectCurrentTableKey);
  const actions = useAppSelector(selectCurrentTableBulkActions);
  const defaultColumns = useAppSelector(selectUserColumns);
  const [columns, setColumns] = useState(defaultColumns || []);
  const [advanceSortColumns, setAdvanceSortColumns] = useState<any[]>([]);

  const bulkSelectColumns = useMemo(() => {
    return defaultColumns.filter((column) => bulkSelectColumnsConfig.includes(column?.id));
  }, [defaultColumns, bulkSelectColumnsConfig]);

  useEffect(() => {
    let newCols = [...defaultColumns];
    if (actions) {
      let index = 0;
      newCols.forEach((c) => {
        if (c.isExpandable) {
          index = c.order + 1;
          return;
        } else {
          return (c.order = c.order + 1);
        }
      });
      // There is no need to explicitly add checkbox column in the client column config
      // If there are actions defined for the current table in the actions constants, we automatically add the checkbox for bulk action
      // This condition just prevents duplication in case someone accidentally adds a checkbox column in the config
      if (!newCols.some((c) => c.id === 'checkbox' || c.isCheckbox)) {
        newCols = newCols.toSpliced(index, 0, {
          label: <TableHeaderCheckbox />,
          disableSort: true,
          hidden: false,
          id: 'checkbox',
          field: 'checkbox',
          order: index,
          isCheckbox: true,
          minWidth: 70,
          maxWidth: 70,
          render: (_cell: any, row: OrderJob) => <TableRowCheckbox data={row} />
        });
      }
    }
    setColumns([...newCols]);
    setAdvanceSortColumns(newCols.filter((column) => !column?.hidden && !column?.disableSort && !!column?.label));
  }, [actions, tableKey, defaultColumns]);

  return { columns, bulkSelectColumns, advanceSortColumns };
};

export default useColumns;
